import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import HeaderBar from '@components/HeaderBar';
import Offer from '@components/Offer/Offer';

const RestrictedPrivilegeFallback: FC = () => {
    const { t } = useTranslation('common');

    return (
        <>
            <HeaderBar title={t('withPrivilegesRequired.trialOver.title')} />
            <Offer />
        </>
    );
};

export default RestrictedPrivilegeFallback;
